// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav_main_container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}

.close-button {
  position: absolute;
  top: 16px;
  right: 14px;
  padding: 5px 14px;
  background-color: #000000;
  border: 1px solid #000000;
  border-radius: 5px;
  cursor: pointer;
  color: #ffffff;
  font-weight: bold;
}
.dropdown-toggle::after {
  display: none !important;
}

.nav_logo_savingz {
  margin-top: 10px;
}
.nav_main_nav {
  width: 90%;
  display: flex;
  justify-content: center;
}
.nav_btn {
  margin-right: 20px;
  margin-top: 15px;
  padding: 15px 40px;
  border: none;
  color: rgb(255, 255, 255);
  letter-spacing: 1.25px;
  font-size: 10px;
  font-family: poppins !important;
  font-weight: 600;
  background: linear-gradient(to right, #7511d3 0%, #691a6f 100%);
}

.nav_btn_two {
  margin-right: 20px;
  border: none;
  padding: 4px 16px 4px 16px;
  gap: 8px;
  border-radius: 8px;

  font-size: 14px;
}

.nav_btn_two:hover {
  background-color: #e1e4ea;
  border-radius: 8px;
}

.nav_btn_three {
  width: Hug (165px) px;
  height: Fixed (44px) px;
  padding: 4px 16px 4px 16px;
  gap: 6px;
  border-radius: 8px;
  color: white;
  border: 1px;
  background: linear-gradient(110.26deg, #9e54e3 1.55%, #57277c 104.79%);
  border: 1px solid #ffffff29;
  box-shadow: 0px 0px 4px 2px #ffffff3d inset;

  box-shadow: 0px 0px 0px 4px #9e54e31a;

  box-shadow: 0px 10px 24px 0px #00000024;

  box-shadow: 0px 6px 10px 0px #0000001a;
}
.nav_btn_three:hover {
  box-shadow: none;
}

.nav_btn:hover {
  background: linear-gradient(to right, #7511d3 0%, #691a6f 80%);
}
.arrow {
  margin-left: 10px;
  vertical-align: middle;
}
.nav_link_container {
  display: flex;
  font-size: 14px !important;
  border-radius: 5px;
  font-weight: 400 !important;
  align-items: center;
  font-family: "inter", sans-serif !important;
}

.nav_link_container:hover {
  background-color: #e1e4ea;
  border-radius: 5px;
}

.nav_arrow {
  margin-right: 5px;
  vertical-align: middle;
}

.nav_items {
  gap: 20px;
  margin-top: 10px;
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
}

/* Add to your CSS file */
@media (max-width: 991px) {
  .nav_btn_two {
    margin-bottom: 10px;
    margin-top: 20px;
    color: black;
    align-items: center;
    width: 100%;
    padding: 15px 0px;
  }
  .nav_btn_three {
    margin-bottom: 10px;
    color: white;
    align-items: center;
    width: 100%;
    padding: 15px 0px;
  }
  .navbar-collapse {
    text-align: left;
  }
  .nav_items {
    align-items: baseline !important;
  }
  .nav-link {
    padding-left: 0; /* Remove padding if necessary */
  }
}

.blur-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  z-index: 999; /* Make sure it's below the modal */
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Optional: to darken the background */
  z-index: 1000; /* Make sure it's on top of other elements */
}
`, "",{"version":3,"sources":["webpack://./src/Navebar/navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sEAAsE;EACtE,2BAA2B;EAC3B,2CAA2C;;EAE3C,qCAAqC;;EAErC,uCAAuC;;EAEvC,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,8DAA8D;AAChE;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,eAAe,EAAE,gCAAgC;EACnD;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAA0B;UAA1B,0BAA0B;EAC1B,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,uCAAuC;EACvE,aAAa,EAAE,4CAA4C;AAC7D","sourcesContent":[".nav_main_container {\n  display: flex;\n  justify-content: center;\n  padding-top: 1.5rem;\n}\n\n.close-button {\n  position: absolute;\n  top: 16px;\n  right: 14px;\n  padding: 5px 14px;\n  background-color: #000000;\n  border: 1px solid #000000;\n  border-radius: 5px;\n  cursor: pointer;\n  color: #ffffff;\n  font-weight: bold;\n}\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.nav_logo_savingz {\n  margin-top: 10px;\n}\n.nav_main_nav {\n  width: 90%;\n  display: flex;\n  justify-content: center;\n}\n.nav_btn {\n  margin-right: 20px;\n  margin-top: 15px;\n  padding: 15px 40px;\n  border: none;\n  color: rgb(255, 255, 255);\n  letter-spacing: 1.25px;\n  font-size: 10px;\n  font-family: poppins !important;\n  font-weight: 600;\n  background: linear-gradient(to right, #7511d3 0%, #691a6f 100%);\n}\n\n.nav_btn_two {\n  margin-right: 20px;\n  border: none;\n  padding: 4px 16px 4px 16px;\n  gap: 8px;\n  border-radius: 8px;\n\n  font-size: 14px;\n}\n\n.nav_btn_two:hover {\n  background-color: #e1e4ea;\n  border-radius: 8px;\n}\n\n.nav_btn_three {\n  width: Hug (165px) px;\n  height: Fixed (44px) px;\n  padding: 4px 16px 4px 16px;\n  gap: 6px;\n  border-radius: 8px;\n  color: white;\n  border: 1px;\n  background: linear-gradient(110.26deg, #9e54e3 1.55%, #57277c 104.79%);\n  border: 1px solid #ffffff29;\n  box-shadow: 0px 0px 4px 2px #ffffff3d inset;\n\n  box-shadow: 0px 0px 0px 4px #9e54e31a;\n\n  box-shadow: 0px 10px 24px 0px #00000024;\n\n  box-shadow: 0px 6px 10px 0px #0000001a;\n}\n.nav_btn_three:hover {\n  box-shadow: none;\n}\n\n.nav_btn:hover {\n  background: linear-gradient(to right, #7511d3 0%, #691a6f 80%);\n}\n.arrow {\n  margin-left: 10px;\n  vertical-align: middle;\n}\n.nav_link_container {\n  display: flex;\n  font-size: 14px !important;\n  border-radius: 5px;\n  font-weight: 400 !important;\n  align-items: center;\n  font-family: \"inter\", sans-serif !important;\n}\n\n.nav_link_container:hover {\n  background-color: #e1e4ea;\n  border-radius: 5px;\n}\n\n.nav_arrow {\n  margin-right: 5px;\n  vertical-align: middle;\n}\n\n.nav_items {\n  gap: 20px;\n  margin-top: 10px;\n  width: 60%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.container {\n  width: 100%;\n}\n\n/* Add to your CSS file */\n@media (max-width: 991px) {\n  .nav_btn_two {\n    margin-bottom: 10px;\n    margin-top: 20px;\n    color: black;\n    align-items: center;\n    width: 100%;\n    padding: 15px 0px;\n  }\n  .nav_btn_three {\n    margin-bottom: 10px;\n    color: white;\n    align-items: center;\n    width: 100%;\n    padding: 15px 0px;\n  }\n  .navbar-collapse {\n    text-align: left;\n  }\n  .nav_items {\n    align-items: baseline !important;\n  }\n  .nav-link {\n    padding-left: 0; /* Remove padding if necessary */\n  }\n}\n\n.blur-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(5px);\n  z-index: 999; /* Make sure it's below the modal */\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Optional: to darken the background */\n  z-index: 1000; /* Make sure it's on top of other elements */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
